import View from './DropItem.view'
import { DropItemProps } from './DropItem.types'
import { useHistory } from 'react-router-dom'
import {
  TO_ASSET_DETAIL,
  TO_DROP_DETAILS,
  TO_MARKETPLACE_ASSET_DETAILS,
} from 'core/modules/router'
import { useDropRemainingCount } from 'core/logic/drop/drop.hook'
import { OfferType } from 'core/logic/drop/drop.types'
import { useTenant } from 'core/logic/tenant/tenant.hook'
import { BaseAssetType } from 'core/logic/asset/asset.types'

export { BaseExpandedWidth, BaseAssetWidth } from './DropItem.view'

function DropViewWithCounter(props: DropItemProps) {
  const history = useHistory()
  const { tenant } = useTenant()
  const remaining = useDropRemainingCount(props.dropOrAsset as OfferType)
  return (
    <View
      {...props}
      tenant={tenant!}
      counters={{
        remaining: remaining,
      }}
      onClick={() => {
        history.push(TO_DROP_DETAILS(props.dropOrAsset.id))
      }}
    />
  )
}

function DropView(props: DropItemProps) {
  const history = useHistory()
  const { tenant } = useTenant()
  return (
    <View
      {...props}
      tenant={tenant!}
      onClick={() => {
        history.push(TO_DROP_DETAILS(props.dropOrAsset.id))
      }}
    />
  )
}

function AssetView(props: DropItemProps) {
  const history = useHistory()
  const { tenant } = useTenant()
  return (
    <View
      {...props}
      tenant={tenant!}
      onClick={() => {
        history.push(TO_ASSET_DETAIL(props.dropOrAsset.id))
      }}
    />
  )
}

function MarketplaceView(props: DropItemProps) {
  const history = useHistory()
  const { tenant } = useTenant()
  return (
    <View
      {...props}
      tenant={tenant!}
      onClick={() => {
        history.push(TO_MARKETPLACE_ASSET_DETAILS(props.dropOrAsset as BaseAssetType))
      }}
    />
  )
}

export default function DropItemLogic(props: DropItemProps) {
  return 'marketplace' in props.dropOrAsset ? (
    <MarketplaceView {...props} />
  ) : props.availability === 'open' && 'asset' in props.dropOrAsset ? (
    <DropViewWithCounter {...props} />
  ) : 'asset' in props.dropOrAsset ? (
    <DropView {...props} />
  ) : (
    <AssetView {...props} />
  )
}
